import React from "react";
import KeywordView from "./Keywords";
import themeLarge from "../ThemeLarge";
import ProjectUrlView from "./ProjectUrl";
import ViewDetailsButton from "./mobile/ViewDetailsBtn";
import { formatPeriodDisplay } from "../../uti";
import { FiShare2 } from "react-icons/fi";
import { showNotification } from "../../uti";
import LoadingLottie from "../Loading";

class ProjectProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      latestProject: props.latestProject,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.latestProject?.id !== this.props.latestProject?.id) {
      this.setState({ latestProject: this.props.latestProject });
    }
  }

  handleCopyProjectLink = async () => {
    try {
      const id = this.props.latestProject?.id || this.state.latestProject?.id;
      if (!id) {
        showNotification("No project ID to share.", "error");
        return;
      }

      const url = `${window.location.origin}/projects/project-${id}`;

      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        // Fallback for older browsers
        const ta = document.createElement("textarea");
        ta.value = url;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }

      showNotification("Link copied to clipboard!", "success", 2500);
    } catch (err) {
      console.error(err);
      showNotification("Failed to copy link. Try again.", "error", 3000);
    }
  };

  render() {
    const { latestProject } = this.state;
    const { isMobile } = this.props;
    return (
      <div
        className="row"
        style={{
          background: themeLarge.colors.secondary,
          padding: "20px",
          borderRadius: "15px",
          boxShadow: themeLarge.shadows.little,
        }}
      >
        {latestProject ? (
          <>
            <div className="col-md-5">
              {/* Title row */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  fontSize: themeLarge.fontSize.h3,
                  color: themeLarge.colors.text,
                  fontWeight: 500,
                  lineHeight: 1.2,
                  marginBottom: "6px",
                }}
              >
                {/* <FiShare2
                  size={20}
                  onClick={this.handleCopyProjectLink}
                  role="button"
                  title="Copy share link"
                  style={{ cursor: "pointer", flexShrink: 0 }}
                /> */}
                <span>{latestProject.name}</span>
              </div>

              {/* Period */}
              <div
                style={{
                  fontSize: themeLarge.fontSize.small,
                  color: "#000",
                  fontWeight: 200,
                  marginBottom: "10px",
                }}
              >
                Project Period:{" "}
                {latestProject.period?.from
                  ? formatPeriodDisplay(
                      latestProject.period.from,
                      latestProject.period?.to || ""
                    )
                  : "---"}
              </div>

              {/* Description */}
              <p
                style={{
                  fontSize: themeLarge.fontSize.body,
                  color: "#000",
                  display: "-webkit-box",
                  WebkitLineClamp: isMobile ? 3 : 4,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  marginBottom: "12px",
                }}
              >
                {latestProject.description}
              </p>

              {/* Keywords */}
              <div
                style={{
                  fontSize: themeLarge.fontSize.body,
                  fontWeight: isMobile ? 500 : 250,
                  marginBottom: "6px",
                }}
              >
                Keywords
              </div>
              <div className="row" style={{ gap: "8px", flexWrap: "wrap" }}>
                {(latestProject.keywords || []).map((word, index) => (
                  <KeywordView key={index} keyword={word} />
                ))}
              </div>
            </div>

            {/* space in between */}
            <div className="col-md-2"></div>
            {/* right */}
            {isMobile && <ViewDetailsButton slug={latestProject.id} />}
            {!isMobile && (
              <>
                <div
                  className="col-md-5"
                  style={{
                    paddingTop: "50px",
                  }}
                >
                  {latestProject.github !== "" ? (
                    <ProjectUrlView
                      url={latestProject.github}
                      title="GitHub"
                    ></ProjectUrlView>
                  ) : null}
                  {latestProject.deploy !== "" ? (
                    <ProjectUrlView
                      url={latestProject.deploy}
                      title="Deploy"
                    ></ProjectUrlView>
                  ) : null}

                  {latestProject.blog !== "" ? (
                    <ProjectUrlView
                      url={latestProject.blog}
                      title="Write-up/Blog"
                    ></ProjectUrlView>
                  ) : null}
                </div>
              </>
            )}
          </>
        ) : (
          <LoadingLottie />
        )}
      </div>
    );
  }
}

export default ProjectProfile;
